
import LegislationBanner from "./LegislationBanner";
import LatestMarineInfo from "../HomePage/LatestMarineInfo";
import SearchInfoComponent from "./SearchInfoComponent";
import LegislationTab from "./LegislationTab/LegislationTab";



function LegislationPage() {
  return (
    <>
      <LegislationBanner/>

      <section className='latest-marine-info px-3' id='latest-marine-info'>
        <div className="container max-1280">
          <SearchInfoComponent/>
        </div>
      </section>

      <LegislationTab/>

      <div className="new_bg_style">
        {/* <Services/> */}    
      </div>
    </>
  )
}

export default LegislationPage;